module.exports = __webpack_public_path__ + "img/onesolution.375656a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/mlstudio/onesolution.svg
// module id = ysSE
// module chunks = 39 44